// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__1jnto","additionalInfo":"AgreementModal_additionalInfo__3_w12"};